import React, { memo, useCallback } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import CountBadge from './CountBadge';
import { StatusFilter } from './jobModel';

const TABS: ReadonlyArray<{ value: StatusFilter; label: string; tone: 'primary' | 'success' | 'info' | 'error' }> = [
  { value: 'all', label: 'All jobs', tone: 'primary' },
  { value: 'completed', label: 'Completed', tone: 'success' },
  { value: 'active', label: 'In progress', tone: 'info' },
  { value: 'failed', label: 'Failed', tone: 'error' },
];

interface StatusTabsProps {
  value: StatusFilter;
  counts: Record<StatusFilter, number>;
  onChange: (value: StatusFilter) => void;
}

const StatusTabs: React.FC<StatusTabsProps> = ({ value, counts, onChange }) => {
  const handleChange = useCallback((_: React.SyntheticEvent, next: StatusFilter) => onChange(next), [onChange]);
  return (
    <Tabs
      value={value}
      onChange={handleChange}
      variant="scrollable"
      scrollButtons={false}
      aria-label="Filter jobs by status"
      sx={{ minHeight: 56, '& .MuiTabs-indicator': { height: 3 } }}
    >
      {TABS.map((tab) => {
        const active = tab.value === value;
        const tone = tab.value === 'failed' && counts.failed > 0 ? 'alert' : active ? tab.tone : 'neutral';
        return (
          <Tab
            key={tab.value}
            value={tab.value}
            disableRipple
            sx={{
              minHeight: 56,
              px: 1.75,
              textTransform: 'none',
              fontSize: 14,
              fontWeight: active ? 600 : 500,
              color: 'text.secondary',
              '&.Mui-selected': { color: 'text.primary' },
            }}
            label={
              <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 1 }}>
                {tab.label}
                <CountBadge count={counts[tab.value]} tone={tone} />
              </Box>
            }
          />
        );
      })}
    </Tabs>
  );
};

export default memo(StatusTabs);
